"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_PAGE_ALIAS_PARAM = void 0;
exports.readAppBasePageAlias = readAppBasePageAlias;
exports.appBasePageAliasQuery = appBasePageAliasQuery;
/**
 * Query parameter that names the shown page where the browser refuses to
 * write its path into the address (Safari inside the sandbox). The address
 * then reads `/?_p=/blog/first-post&lang=de`: the query of the page stays a
 * query of the address, so an App reads its own parameters as always. Loading
 * such an address answers with a redirect to the page itself.
 */
exports.APP_BASE_PAGE_ALIAS_PARAM = '_p';
/**
 * Route a query names as a page alias, as `/path?query` with every other
 * parameter of the query as written. `null` when the query names no page
 * below the own address, so it never leads to another origin.
 * Embedded as a function, so it uses nothing outside its own body.
 */
function readAppBasePageAlias(query) {
    if (typeof query !== 'string')
        return null;
    const parts = query.replace(/^\?/, '').split('&');
    const isAlias = (part) => part === '_p' || part.startsWith('_p=');
    // The platform writes its parameter first; a later one changes nothing.
    const named = parts.find(isAlias);
    if (named === undefined)
        return null;
    let value;
    try {
        value = decodeURIComponent(named.slice(3).replace(/\+/g, ' '));
    }
    catch {
        return null;
    }
    if (!/^\/(?![/\\])/.test(value))
        return null;
    // The browser reads a backslash as a slash and drops tab and line breaks.
    if (value.includes('\\'))
        return null;
    for (let index = 0; index < value.length; index += 1) {
        const code = value.charCodeAt(index);
        if (code < 32 || code === 127)
            return null;
    }
    let target;
    try {
        target = new URL(value, 'https://route.invalid');
    }
    catch {
        return null;
    }
    if (target.origin !== 'https://route.invalid')
        return null;
    // `/.//host` is a path here and another origin once it is an address.
    if (/^\/[/\\]/.test(target.pathname))
        return null;
    const rest = parts.filter(part => part !== '' && !isAlias(part)).join('&');
    return target.pathname + (rest ? '?' + rest : '');
}
/**
 * Query that names `route` (`/path?query`) as the shown page.
 * Embedded as a function, so it uses nothing outside its own body.
 */
function appBasePageAliasQuery(route) {
    const at = route.indexOf('?');
    const path = at < 0 ? route : route.slice(0, at);
    const rest = (at < 0 ? '' : route.slice(at + 1))
        .split('&')
        .filter(part => part !== '' && part !== '_p' && !part.startsWith('_p='))
        .join('&');
    // Slashes stay readable; everything that would end the value is encoded.
    const page = encodeURIComponent(path).replace(/%2F/gi, '/');
    return '?_p=' + page + (rest ? '&' + rest : '');
}
